import { render, staticRenderFns } from "./ConcordiaChem206Experiment1Part2.vue?vue&type=template&id=84e1ff34&scoped=true&"
import script from "./ConcordiaChem206Experiment1Part2.vue?vue&type=script&lang=ts&"
export * from "./ConcordiaChem206Experiment1Part2.vue?vue&type=script&lang=ts&"
import style0 from "./ConcordiaChem206Experiment1Part2.vue?vue&type=style&index=0&id=84e1ff34&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84e1ff34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCol,VContainer,VDataTable,VIcon,VRow,VTextField})
